module.exports = __webpack_public_path__ + "static/media/clinician-leads-to-stroke-1080p.4a02be80.mp4";